// Auto generated file, do not manually modify!
// com.hotpads.satellite.web.service.rentalapplication.SatelliteRentalApplicationDisplayStateType

export enum SatelliteRentalApplicationDisplayStateType {
  APPLICATION_REQUESTED = 'APPLICATION_REQUESTED',
  APPLY_NOW = 'APPLY_NOW',
  DO_NOT_DISPLAY = 'DO_NOT_DISPLAY',
  REQUEST_TO_APPLY = 'REQUEST_TO_APPLY',
  VIEW_APPLICATION = 'VIEW_APPLICATION',
}

export const SatelliteRentalApplicationDisplayStateType_values = [
  SatelliteRentalApplicationDisplayStateType.APPLICATION_REQUESTED,
  SatelliteRentalApplicationDisplayStateType.APPLY_NOW,
  SatelliteRentalApplicationDisplayStateType.DO_NOT_DISPLAY,
  SatelliteRentalApplicationDisplayStateType.REQUEST_TO_APPLY,
  SatelliteRentalApplicationDisplayStateType.VIEW_APPLICATION,
] as const;
